export const CYBERINT_DOMAIN = 'cyberint.com';
export const CHECKPOINT_DOMAIN = 'checkpoint.com';
export const INTERNAL_USER_EMAIL_DOMAINS = [`@${CHECKPOINT_DOMAIN}`, `@${CYBERINT_DOMAIN}`];
